export const roomMapStore = {
    namespaced: true,
    state: {
        roomMapId: null, // ID aktualnej planszy
        roomMaps: [],
        isShowAddRoomMap: false,
        selectedRoomMap: null,
        currentActiveRoomMap: null
    },
    mutations: {
        setRoomMapId(state, roomMapId) {
            state.roomMapId = roomMapId
        },
        setAvailableRoomMaps(state, roomMaps) {
            state.roomMaps = roomMaps;
        },
        setIsShowAddRoomMapStatus(state, status) {
            if (status === false) {
                state.selectedRoomMap = null;
            }
            state.isShowAddRoomMap = status;
        },
        setSelectedRoomMap(state, item) {
            state.selectedRoomMap = item;
        },
        setActiveRoomMap(state, roomMap) {
            state.currentActiveRoomMap = roomMap
        }
    },
    actions: {
        setRoomMapId({ commit }, roomMapId) {
            commit('setRoomMapId', roomMapId)
        }
    }
}
